import { useRuntimeConfig } from "#imports";
export function useGAEvent(action, params = {}) {
  if (!process.client)
    return;
  window.gtag("event", action, params);
}
export function useGAConfig(params = {}, id) {
  if (!process.client)
    return;
  const config = useRuntimeConfig().public.gAnalytics;
  const tagId = id || config.measurementId;
  if ("page_location" in params) {
    params.page_location = location.origin + params.page_location;
  }
  window.gtag("config", tagId, params);
}
export function useGAGet(target, field, callback) {
  if (!process.client)
    return;
  window.gtag("get", target, field, callback());
}
export function useGASet(params = {}) {
  if (!process.client)
    return;
  window.gtag("set", params);
}
export function useGAConsent(arg, params = {}) {
  if (!process.client)
    return;
  window.gtag("consent", arg, params);
}
